import { motion, useReducedMotion } from '@/lib/motion';

/**
 * Animated voice waveform — the visual shorthand for "a live call".
 * Pure SVG-free div bars driven by framer-motion so it inherits
 * MotionConfig's reduced-motion handling (static mid-height bars).
 */
export function Waveform({
  bars = 24,
  className = '',
  barClassName = 'bg-[var(--brand-accent)]',
}: {
  bars?: number;
  className?: string;
  barClassName?: string;
}): JSX.Element {
  const reduced = useReducedMotion();
  return (
    <div
      aria-hidden="true"
      className={`flex items-center justify-center gap-[3px] ${className}`}
    >
      {Array.from({ length: bars }).map((_, i) => {
        // Deterministic pseudo-random peaks so SSR/prerender output is stable.
        const peak = 0.35 + (((i * 7919) % 100) / 100) * 0.65;
        return (
          <motion.span
            key={i}
            className={`w-[3px] rounded-full ${barClassName}`}
            style={{ height: '100%', originY: 0.5 }}
            animate={
              reduced
                ? { scaleY: 0.5 }
                : { scaleY: [0.2, peak, 0.3, peak * 0.8, 0.2] }
            }
            transition={
              reduced
                ? undefined
                : {
                    duration: 1.2 + ((i * 13) % 7) * 0.1,
                    repeat: Infinity,
                    ease: 'easeInOut',
                    delay: (i % 9) * 0.08,
                  }
            }
          />
        );
      })}
    </div>
  );
}
